// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-cntbn,
.em-cntbn-halo,
.em-kosovo-bn,
.em-bn-co {
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
    pointer-events: none;
}

/* coastal boundaries */
.em-bn-co {
    stroke: white;
}

/* kosovo */
.em-kosovo-bn {
    stroke: #3f3f3f;
    stroke-width: 0.15;
    opacity: 0.8;
}

/* country boundaries */
.em-cntbn {
    stroke: #353535;
    stroke-width: 0.8px;
    opacity: 1;
}

/* country boundary halo (not coastline) */
.em-cntbn-halo:not(.em-bn-co) {
    stroke: white;
    stroke-width: 1.5px;
    opacity: 1;
}

/* NUTS boundaries stroke color */
.em-bn-1,
.em-bn-2,
.em-bn-3,
.em-nutsrg [lvl='3'],
.em-nutsrg [lvl='2'],
.em-nutsrg [lvl='1'] {
    stroke: #868686;
}

/*  boundaries stroke-width */
.em-bn-0 {
    stroke: none;
}
.em-bn-1,
.em-bn-2,
.em-bn-3,
/* when using MIXED NUTS levels, we add stroke to the regions, then show/hide those that have/dont have data */
.em-nutsrg [lvl='3'],
.em-nutsrg [lvl='2'],
.em-nutsrg [lvl='1'],
.em-bn-co {
    /* coastal boundaries must block MIXED NUTS levels polygon stroke */
    stroke-width: 0.4;
}

/* all NUTS boundaries and regions */
#em-nutsbn,
.em-bn-0,
.em-bn-1,
.em-bn-2,
.em-bn-3,
.em-nutsrg [lvl='3'],
.em-nutsrg [lvl='2'],
.em-nutsrg [lvl='1'],
.em-nutsrg {
    stroke-linecap: round;
    stroke-linejoin: round;
}

/* dont fill border elements */
.em-bn-0,
.em-bn-1,
.em-bn-2,
.em-bn-3 {
    fill: none;
    pointer-events: none;
}

/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */
/* g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {
    opacity: 0;
} */
`, "",{"version":3,"sources":["webpack://./src/css/borders.css"],"names":[],"mappings":"AAAA;;;;IAII,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,oBAAoB;AACxB;;AAEA,uBAAuB;AACvB;IACI,aAAa;AACjB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;AACd;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA,iCAAiC;AACjC;;;;;;IAMI,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,YAAY;AAChB;AACA;;;;;;;;IAQI,mEAAmE;IACnE,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;;;;;;;;;IASI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;;;;IAII,UAAU;IACV,oBAAoB;AACxB;;AAEA,uHAAuH;AACvH;;GAEG","sourcesContent":[".em-cntbn,\r\n.em-cntbn-halo,\r\n.em-kosovo-bn,\r\n.em-bn-co {\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n    fill: none;\r\n    pointer-events: none;\r\n}\r\n\r\n/* coastal boundaries */\r\n.em-bn-co {\r\n    stroke: white;\r\n}\r\n\r\n/* kosovo */\r\n.em-kosovo-bn {\r\n    stroke: #3f3f3f;\r\n    stroke-width: 0.15;\r\n    opacity: 0.8;\r\n}\r\n\r\n/* country boundaries */\r\n.em-cntbn {\r\n    stroke: #353535;\r\n    stroke-width: 0.8px;\r\n    opacity: 1;\r\n}\r\n\r\n/* country boundary halo (not coastline) */\r\n.em-cntbn-halo:not(.em-bn-co) {\r\n    stroke: white;\r\n    stroke-width: 1.5px;\r\n    opacity: 1;\r\n}\r\n\r\n/* NUTS boundaries stroke color */\r\n.em-bn-1,\r\n.em-bn-2,\r\n.em-bn-3,\r\n.em-nutsrg [lvl='3'],\r\n.em-nutsrg [lvl='2'],\r\n.em-nutsrg [lvl='1'] {\r\n    stroke: #868686;\r\n}\r\n\r\n/*  boundaries stroke-width */\r\n.em-bn-0 {\r\n    stroke: none;\r\n}\r\n.em-bn-1,\r\n.em-bn-2,\r\n.em-bn-3,\r\n/* when using MIXED NUTS levels, we add stroke to the regions, then show/hide those that have/dont have data */\r\n.em-nutsrg [lvl='3'],\r\n.em-nutsrg [lvl='2'],\r\n.em-nutsrg [lvl='1'],\r\n.em-bn-co {\r\n    /* coastal boundaries must block MIXED NUTS levels polygon stroke */\r\n    stroke-width: 0.4;\r\n}\r\n\r\n/* all NUTS boundaries and regions */\r\n#em-nutsbn,\r\n.em-bn-0,\r\n.em-bn-1,\r\n.em-bn-2,\r\n.em-bn-3,\r\n.em-nutsrg [lvl='3'],\r\n.em-nutsrg [lvl='2'],\r\n.em-nutsrg [lvl='1'],\r\n.em-nutsrg {\r\n    stroke-linecap: round;\r\n    stroke-linejoin: round;\r\n}\r\n\r\n/* dont fill border elements */\r\n.em-bn-0,\r\n.em-bn-1,\r\n.em-bn-2,\r\n.em-bn-3 {\r\n    fill: none;\r\n    pointer-events: none;\r\n}\r\n\r\n/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */\r\n/* g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {\r\n    opacity: 0;\r\n} */\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
